import type { QuaternionSignalModalityV1, SignalWindowV1 } from "@rekonas/domain";
import { orientationModelForModality } from "./config";
import { orientationAtTime, type OrientationSelection } from "./orientation";
import { positionAngle, projectionThresholdForDegrees, verticalPosition } from "./combinedOrientation";
import { quadrantAt } from "./presentationProfiles";
export interface PresentationSample { start:number; end:number; value:number|null; state:string; }
export interface PositionValue { angle:number|null; quadrant:number|null; state:string; }
export function positionValue(selection:OrientationSelection,thresholdDegrees:number):PositionValue {
  if(selection.state !== "available")return {angle:null,quadrant:null,state:selection.reason === "invalid" || selection.reason === "mapping"?"Invalid":"Missing"};
  const threshold=projectionThresholdForDegrees(thresholdDegrees);
  const vertical=verticalPosition(selection.model,threshold);
  const angle=positionAngle(selection.model,threshold);
  return {angle,quadrant:angle===null?null:quadrantAt(angle),state:vertical || (angle===null?"Invalid":"available")};
}
/** Display-only samples from one bounded native window, never quaternion min/max envelopes. */
export function positionSamples(window:SignalWindowV1|undefined,modality:QuaternionSignalModalityV1,threshold:number):PresentationSample[] {
  const source=window?.series.find(s=>s.modality_id===modality.id&&s.representation === "native"&&modality.components.w.includes(s.channel_label));
  const config=orientationModelForModality(modality.id);
  if(!window||!source||source.representation!=="native"||!config)return [];
  return source.values.map((_,index)=>{
    const start=source.start_seconds+index*source.sample_period_seconds;
    const value=positionValue(orientationAtTime(window,modality,start,config.calibrationWxyz),threshold);
    return {start,end:Math.min(window.interval.end_seconds,start+source.sample_period_seconds),value:value.angle,state:value.state};
  });
}
